import React from 'react';
import '../../styles/projects/projects.css';
import { ReactComponent as MicroscopeIcon } from '../../assets/svg/analyze-svg.svg';
import { ReactComponent as TestTubeIcon } from '../../assets/svg/test-tube-svg.svg';
import { ReactComponent as DataIcon } from '../../assets/svg/data-svg.svg';
import { ReactComponent as ExperimentIcon } from '../../assets/svg/experiment.svg';
import { ReactComponent as HandshakeIcon } from '../../assets/svg/handshake.svg';

const ProjectsIntro = ({ onWpButtonClick }) => {
	return (
		<section className="projects-intro">
			<h2>Project execution</h2>
			<p>
				For rapid launch of this plan, we have already initiated development of prospective observational trials in ongoing population-based 
				lung cancer initiatives in Stockholm (PreDDLung, {' '}
				<a href="https://ki.se/personer/simon-ekman" target="_blank" rel="noopener noreferrer">PI Simon Ekman)</a> and Lund (LUCAS, PI {' '}
				<a href="https://www.lu.se/lucat/user/849eb7fe92c1ca1ad15ecdc71512e6ca" target="_blank" rel="noopener noreferrer"> Maria Planck)</a> . Moreover, we have teamed up with 
				planning of national cancer drug repurposing trial (FOCU.SE, PI Edvard Abel) where proteomics sampling and current SOPs are developed 
				at BioMS node at Stockholm and are part of the trial protocol. Notably, in the joint <a href="https://www.testbedswedenphc.se/focuse" target="_blank" rel="noopener noreferrer">FOCU.SE</a> meeting with seven leading pharma 
				companies, the proteome medicine initiative was lifted as an internationally competitive edge initiative and very much encouraged 
				by the Pharma.
			</p>
			<div className="projects-intro-wp-buttons">
				<button onClick={() => onWpButtonClick('WP1')}>WP1 <MicroscopeIcon /> </button>
				<button onClick={() => onWpButtonClick('WP2')}>WP2 <TestTubeIcon /> </button>
				<button onClick={() => onWpButtonClick('WP3')}>WP3 <DataIcon /> </button>
				<button onClick={() => onWpButtonClick('WP4')}>WP4 <ExperimentIcon /> </button>
				<button onClick={() => onWpButtonClick('WP5')}>WP5 <HandshakeIcon /> </button>
			</div>
		</section>
	);
};

export default ProjectsIntro;
